import React from 'react';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import {
  Modal as ModalV1,
  ModalAnimation,
} from '../../index';
import ActionBar from '../../ActionBar';

const Modal = ({
  isOpen,
  header,
  footerActions,
  tertiaryText,
  type,
  onClose,
  children,
  size,
  roundedCorners,
  headerDivider,
  bottomDivider,
  hideFooter,
  bodyColor,
  position,
  style,
}) => {
  const footer = (isHidden) => (
    !isHidden && (
      <ActionBar
        footerActions={footerActions}
        tertiaryText={tertiaryText}
      />
    )
  );

  return (
    <TransitionGroup>
      { isOpen
        && (
        <ModalAnimation>
          <ModalV1
            isOpen
            header={header}
            headerDivider={headerDivider}
            bottomDivider={bottomDivider}
            hasActionBar
            footer={footer(hideFooter)}
            size={size}
            type={type}
            onCloseClick={onClose}
            roundedCorners={roundedCorners}
            bodyColor={bodyColor}
            position={position}
            bodyStyle={style}
          >
            {children}
          </ModalV1>
        </ModalAnimation>
        )}
    </TransitionGroup>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  footerActions: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
    onClick: PropTypes.func,
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['primary', 'secondary', 'danger', 'text', 'custom']),
    disabled: PropTypes.bool,
    customComponent: PropTypes.element,
  })),
  tertiaryText: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['success', 'info', 'secondary', 'danger', 'text']),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'extraLarge']),
  roundedCorners: PropTypes.bool,
  bodyColor: PropTypes.oneOf(['default', 'gray10', 'gray30']),
  hideFooter: PropTypes.bool,
  position: PropTypes.oneOf(['default', 'center']),
  style: PropTypes.object,
};

Modal.defaultProps = {
  footerActions: undefined,
  tertiaryText: '',
  header: undefined,
  headerDivider: true,
  bottomDivider: true,
  isOpen: false,
  type: 'secondary',
  size: 'medium',
  roundedCorners: true,
  bodyColor: 'default',
  hideFooter: false,
  position: 'default',
  style: {},
};

export default Modal;
